import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { PUBLIC_URL } from "../../app.config";
import SubNavbar from "../../layout/SubNavbar";
import { setLoader } from "../../Store/slices/MasterSlice";
import { editBadgeApiCall } from "../../Store/slices/badgeSlice";
import { uploadImageOnAWS } from "../../utils/aws.service";
import { convertToBase64, TOAST_ERROR } from "../../utils/common.service";

export default function EditBadge() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const clientData = location?.state?.clientData;

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    control,
    setValue,
    clearErrors,
  } = useForm();

  const [badgeImageState, setBadgeImageState] = useState(
    PUBLIC_URL + "/assets/images/default_logo.jpg"
  );

  useEffect(() => {
    if (clientData) {
      setBadgeImageState(clientData?.badge_image || badgeImageState);
      reset({
        badge_name: clientData?.name || "",
        arebic_name: clientData?.arebic_name || "",
        badge_points: clientData?.points || "",
      });
    }
  }, [clientData, reset]);

  const handleImageChange = async (image, field) => {
    const imageSize = image.size / 1024; // convert to KB
    if (imageSize > 3072) {
      TOAST_ERROR("Please select an image smaller than 3MB");
    } else {
      setValue(field, image);
      const bufferImage = await convertToBase64(image);
      setBadgeImageState(bufferImage); // Set the badge image preview
      clearErrors(field);
    }
  };

  const onSubmit = async (submitData) => {
    try {
      dispatch(setLoader(true));

      let requestBody = {
        id: clientData?.id,
        name: submitData.badge_name,
        arebic_name: submitData.arebic_name,
        points: submitData.badge_points,
      };

      let badgeImage = submitData.badge_image;
      if (badgeImage instanceof Blob) {
        badgeImage = await uploadImageOnAWS(badgeImage, "badge");
        requestBody.image = badgeImage;
      }

      await dispatch(editBadgeApiCall(requestBody));
      navigate(`/manage_badge`);
      reset();
      dispatch(setLoader(false));
    } catch (err) {
      TOAST_ERROR(err.message);
      dispatch(setLoader(false));
    }
  };

  return (
    <div className="content">
      <div className="container-fluid">
        <SubNavbar
          title={`Edit Badge`}
          header={`Badge`}
          subHeader={`Edit Badge`}
        />
        <div className="card rounded-3">
          <div className="card-body">
            <div className="d-flex justify-content-lg-start">
              <button
                type="button"
                className="btn btn-light"
                onClick={() => navigate(-1)}
              >
                <i className="bi bi-arrow-left"></i>
              </button>
            </div>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mb-3">
                {/* Badge Image */}
                <div className="col-md-12 d-flex justify-content-center" >
                  <Controller
                    name="badge_image"
                    control={control}
                    defaultValue={null}
                    render={({ field }) => (
                      <div className="d-flex flex-column align-items-center">
                        <img
                          src={badgeImageState}
                          alt="Badge image"
                          className="img-fluid img-thumbnail"
                          style={{
                            width: "120px",
                            height: "120px",
                            borderRadius: "10%",
                          }}
                        />
                        <label htmlFor="badgeImage">
                          <div className="upload-document mt-2">
                            <div className="btn btn-outline-info m-1">
                              Choose Badge Image
                            </div>
                          </div>
                        </label>
                      </div>
                    )}
                  />
                  <input
                    type="file"
                    id="badgeImage"
                    style={{ display: "none" }}
                    onChange={(e) =>
                      handleImageChange(e.target.files[0], "badge_image")
                    }
                    accept=".jpg, .jpeg, .png"
                  />
                  <div className="errorc">{errors.badge_image?.message}</div>
                </div>
              </div>

              {/* Badge Name and Points */}
              <div className="row mb-3">
                <div className="col-md-4">
                  <label htmlFor="badge_name" className="form-label">
                    Badge Name
                  </label>
                  <input
                    type="text"
                    id="badge_name"
                    className="form-control"
                    placeholder="Enter Badge Name"
                    {...register("badge_name", {
                      required: "Badge Name is required",
                    })}
                  />
                  <div className="errorc">{errors.badge_name?.message}</div>
                </div>

                <div className="col-md-4">
                  <label htmlFor="arebic_name" className="form-label">
                    Badge Arebic Name
                  </label>
                  <input
                    type="text"
                    id="arebic_name"
                    className="form-control"
                    placeholder="Enter Badge Arebic Name"
                    {...register("arebic_name", {
                      required: "Badge Arebic Name is required",
                    })}
                  />
                  <div className="errorc">{errors.arebic_name?.message}</div>
                </div>

                <div className="col-md-4">
                  <label htmlFor="badge_points" className="form-label">
                    Points
                  </label>
                  <input
                    type="number"
                    id="badge_points"
                    className="form-control"
                    placeholder="Enter Points"
                    {...register("badge_points", {
                      required: "Badge Points are required",
                    })}
                  />
                  <div className="errorc">{errors.badge_points?.message}</div>
                </div>
              </div>

              <div className="d-flex justify-content-center mt-3">
                <button className="btn btn-primary m-1" type="submit">
                  Update Badge
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
